import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes, Route } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
// import cfg_example from '../../../../modules/example/workflows/workflow-config';

// const routes: Routes = [];
// const workflows = cfg_example.workflows;

// for (const wf of workflows) {
//     for (const s of wf.states) {
//         routes.push({
//             path: `w${wf.id}-s${s.id}`,
//             loadChildren: s.module,
//             outlet: 'processor',
//         } as Route);
//     }
// }

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: 'tasks',
                component: DashboardComponent,
                // children: routes
            }
        ])
    ],
    exports: [
        RouterModule
    ]
})
export class DashboardRoutingModule {
}
